import { render, staticRenderFns } from "./TermicCourseList.vue?vue&type=template&id=1af8b434"
import script from "./TermicCourseList.vue?vue&type=script&lang=js"
export * from "./TermicCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports